var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMasterCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1689 17.1053C15.0545 18.0447 13.6089 18.6118 12.0293 18.6118C8.5047 18.6118 5.64746 15.7885 5.64746 12.3059C5.64746 8.82324 8.5047 6 12.0293 6C13.6089 6 15.0545 6.56709 16.1689 7.50646C17.2833 6.56709 18.7289 6 20.3086 6C23.8332 6 26.6904 8.82324 26.6904 12.3059C26.6904 15.7885 23.8332 18.6118 20.3086 18.6118C18.7289 18.6118 17.2833 18.0447 16.1689 17.1053Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.168 17.1058C17.5401 15.9492 18.4102 14.2282 18.4102 12.3064C18.4102 10.3845 17.5401 8.66351 16.168 7.5069C17.2824 6.56755 18.7279 6.00049 20.3076 6.00049C23.8321 6.00049 26.6894 8.82373 26.6894 12.3064C26.6894 15.789 23.8321 18.6123 20.3076 18.6123C18.7279 18.6123 17.2824 18.0452 16.168 17.1058Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1683 17.1053C17.5404 15.9487 18.4105 14.2277 18.4105 12.3058C18.4105 10.384 17.5404 8.66296 16.1683 7.50635C14.7961 8.66296 13.926 10.384 13.926 12.3058C13.926 14.2277 14.7961 15.9487 16.1683 17.1053Z",
    fill: "#FF5E00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMasterCard);
export default __webpack_public_path__ + "static/media/IconMasterCard.55ae7102.svg";
export { ForwardRef as ReactComponent };